// This file was auto-generated by Fern from our API Definition.
export var ApplicationRevisionDataInput;
(function (ApplicationRevisionDataInput) {
    ApplicationRevisionDataInput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(ApplicationRevisionDataInput || (ApplicationRevisionDataInput = {}));
